import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import classNames from "classnames";
import Tooltip from "@mui/material/Tooltip";

//ICONS
import DownloadIcon from "../../../../assets/img/card-icons/file_save.svg";
import mail from "../../../../assets/img/card-icons/mail.svg";
import "../../results/results.scss";

export const TarjetaCertificadosComponent = ({
  result,
  eventPreview,
  eventDownload,
  eventMail,
  eventShare
}) => {  
  
  return (
    <div
      className={"tarjeta--activa shadow mt-2"}
    >
      <div
        // className="d-flex justify-content-start align-items-center"        
        style={{display:"flex",flexDirection:"column",gap:"10px"}}
      >
        <div>
            <span className="resultado-etiqueta">Fecha:</span>
            <span className="resultado-valor">{result.date.slice(0,10)}</span>
        </div>
        <div>
            <span className="resultado-etiqueta">Tipo de documento:</span>
            <span className="resultado-valor">{result.type}</span>
        </div>
        <div>
            <span className="resultado-etiqueta">Servicio:</span>
            <span className="resultado-valor">{result.name}</span>
        </div>
      </div>  
      <div class="separador" style={{width:"100%",borderTopWidth:"2px"}}></div>    
      <div className="iconos-acciones-tarjeta iconos-acciones-tarjeta--certificados">
    
        <Tooltip title="Descargar certificado" placement="top" arrow>
          <span>
            <img
              src={DownloadIcon}
              alt="Descargar certificado"
              className="i-25-result-download pointer"
              onClick={() => eventDownload(result)}
            />
          </span>
        </Tooltip>
        <img src={mail} alt="Email" onClick={()=>eventMail(result)} />
      </div>
    </div>
  );
};
